import { IEnumResponse } from "../../interfaces/i-enum";

export function hasFlag(value: number, flag: number | string): boolean {
    return (value & Number(flag)) === flag;
}

export function getMissingFlags(bitmask: number, enumList: IEnumResponse[]) {
    return enumList.filter(item => item.value !== 0 && !hasFlag(bitmask, item.value));
}